import { FoodType } from '../../constants/foodType';
import { DatabaseFoodItem } from '../../interfaces/DatabaseFoodItem';
import { FoodListItem } from '../../interfaces/FoodListItem';
import { goTo } from '../../../shared/utils/angularUtils';
import { foodTemplateStorage } from '../foodTemplateStorage/foodTemplateStorage';
import { pathQueryParams } from '../../constants/pathQueryParams';
import { FoodDetails } from '../../interfaces/FoodDetails';

/** Opens the food form prefilled from `food`. */
export const goToAddFoodWithTemplate = (
  food: FoodListItem | DatabaseFoodItem | FoodDetails,
  foodType: FoodType,
) => {
  const templateId = foodTemplateStorage.set(food);

  goTo(`/add-food/${foodType}`, { params: { [pathQueryParams.template]: templateId } });
};
